var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7067 6.70748C25.8943 6.51995 26 6.26522 26 6C26 5.73478 25.8946 5.48043 25.7071 5.29289L25.6985 5.28436C25.5117 5.1024 25.2607 5 25 5C24.7348 5 24.4804 5.10536 24.2929 5.29289L14.2929 15.2929C14.1054 15.4804 14 15.7348 14 16C14 16.2652 14.1054 16.5196 14.2929 16.7071L24.2929 26.7071C24.4804 26.8946 24.7348 27 25 27C25.2652 27 25.5196 26.8946 25.7071 26.7071C25.8946 26.5196 26 26.2652 26 26C26 25.7348 25.8946 25.4804 25.7071 25.2929L16.4142 16L25.7067 6.70748Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7067 6.70748C15.8943 6.51995 16 6.26522 16 6C16 5.73478 15.8946 5.48043 15.7071 5.29289L15.6985 5.28436C15.5117 5.1024 15.2607 5 15 5C14.7348 5 14.4804 5.10536 14.2929 5.29289L4.29289 15.2929C4.10536 15.4804 4 15.7348 4 16C4 16.2652 4.10536 16.5196 4.29289 16.7071L14.2929 26.7071C14.4804 26.8946 14.7348 27 15 27C15.2652 27 15.5196 26.8946 15.7071 26.7071C15.8946 26.5196 16 26.2652 16 26C16 25.7348 15.8946 25.4804 15.7071 25.2929L6.41421 16L15.7067 6.70748Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeftIcon);
export default __webpack_public_path__ + "static/media/doubleArrowLeftIcon.f9e7c4f7981780a9a1700f0ff2977a30.svg";
export { ForwardRef as ReactComponent };